<!-- DYNAMIC SHOWCASE -->
<div *ngIf="dynamic" [ngStyle]="getShowcaseStyles()" [ngClass]="showcase.className">
  <div *ngIf="showcase.title" fxLayoutAlign="start end">
    <span
      class="ag-pa-sm"
      [ngStyle]="{ background: showcase?.titleBackground }"
      style="font-size: 1.1em; font-weight: 500"
    >
      {{ showcase.title }}
    </span>
  </div>
  <div #swipe class="swiper">
    <div class="swiper-wrapper">
      <div
        *ngIf="(documents$ | async).length === 0"
        class="text-center"
        style="width: 100%; position: relative; height: 250px; vertical-align: middle; top: 45%"
      >
        <div *ngIf="loading">
          <mat-spinner
            [diameter]="25"
            strokeWidth="3"
            color="accent"
            style="display: inline-block; position: relative; margin-top: 5em"
          ></mat-spinner>
        </div>
      </div>
      <div *ngFor="let doc of documents$ | async" class="pointer swiper-slide">
        <div class="jacketarturl pointer slick-img" tabindex="0" (agInteract)="goToFullRecord(doc)">
          <img
            [alt]="doc.title"
            [src]="doc.jacketArt.small"
            [title]="doc.title"
            class="max-height-100"
            onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
          />
        </div>
        <div class="captions" tabindex="0" (keyup.enter)="goToFullRecord(doc)">
          <div class="mat-body-strong ellipsis">{{ doc.title }}</div>
          <div>
            <div class="ellipsis">{{ doc.author }}</div>
            <div class="ellipsis">{{ doc.publisher }}</div>
            <div class="ellipsis">{{ doc.format_Long }}</div>
            <div class="ellipsis" *ngIf="doc.pubYear">
              <span *ngFor="let date of doc.pubYear">
                {{ date }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div #swipePrev class="swiper-button-prev"></div>
    <div #swipeNext class="swiper-button-next"></div>
  </div>
</div>
<!-- STATIC SHOWCASE -->
<div
  *ngIf="!dynamic"
  class="showcaseDiv static list-showcase"
  [ngStyle]="getShowcaseStyles()"
  [ngClass]="showcase?.className"
>
  <div *ngIf="showcase.title" fxLayoutAlign="start end">
    <span
      class="ag-pa-sm"
      [ngStyle]="{ background: showcase.titleBackground }"
      style="font-size: 1.1em; font-weight: 500"
    >
      {{ showcase.title }}
    </span>
  </div>
  <div
    *ngIf="loading"
    class="text-center"
    style="width: 100%; position: relative; height: 250px; vertical-align: middle; top: 45%"
  >
    <mat-spinner
      strokeWidth="3"
      color="accent"
      style="display: inline-block; position: relative; margin-top: 5em"
      [diameter]="25"
    ></mat-spinner>
  </div>

  <div #swipe class="swiper">
    <div class="swiper-wrapper">
      <div *ngFor="let item of listItems$ | async" class="pointer swiper-slide">
        <div
          class="jacketarturl pointer slick-img"
          tabindex="0"
          (agInteract)="goToFullRecordList(item)"
        >
          <img
            [alt]="item.title"
            [src]="item.jacketArt.small"
            [title]="item.title"
            class="max-height-100"
            onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
          />
        </div>
        <div class="captions" tabindex="0" (keyup.enter)="goToFullRecordList(item)">
          <div
            class="mat-body-strong ellipsis"
            tabindex="0"
            (agInteract)="goToFullRecordList(item)"
          >
            {{ item.title }}
          </div>
          <div>
            <div class="ellipsis">{{ item.author }}</div>
            <div class="ellipsis">{{ item.publisher }}</div>
            <div *ngIf="item.pubYear !== ''" class="ellipsis">
              {{ item.pubYear }}
            </div>
            <div *ngIf="item.formatType !== ''" class="ellipsis">
              {{ item.formatType }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div #swipePrev class="swiper-button-prev"></div>
    <div #swipeNext class="swiper-button-next"></div>
  </div>
</div>
<!-- display message for static showcase -->
<div *ngIf="(message$ | async) && !loading" class="text-center">
  <h4>{{ message$ | async }}</h4>
</div>
